import styled from "styled-components";

const ExploreMoreStyled = styled.div`
`

export default ExploreMoreStyled;
